<template>
  <div v-if="title" class="auto-renewal-confirmation">
    <Header :noNav="false"></Header>
    <b-container>
      <b-row>
        <div class="auto-renewal-confirmation__row">
          <span class="auto-renewal-confirmation__icon" :class="`icon--${icon}`" />
          <h1>{{ title }}</h1>
          <p v-if="description" v-html="description"></p>
        </div>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import Header from '../Header/Header'

export default {
  name: 'AutoRenewalConfirmation',
  components: { Header },
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    }

  },
  beforeMount () {
    if (!this.title) {
      this.$router.push({
        name: 'AutoRenewalManagement'
      })
    }
  }
}
</script>
<style lang="scss" scoped>
$breakpoint-mobile: 480px;

.auto-renewal-confirmation {
  background-color: #f5f7fa;
  min-height: 100%;

  &__row {
    text-align: center;
    width: 100%;
    margin-top: 48px;
    padding: 0 8px;

    h1 {
      color: #444444;
      font: bold 32px Oscine;
      max-width: 600px;
      margin: 12px auto 24px auto;

      @media only screen and (max-width: $breakpoint-mobile) {
        font-size: 24px;
      }
    }

    p {
      font-family: Rubik;
      color: #595959;
      font-size: 16px;
      margin: 0 auto !important;
      max-width: 568px;
    }
  }

  &__icon {
    width: 48px;
    height: 48px;
    border-radius: 100%;
    display: inline-block;

    &.icon--success {
      background: url(~@/assets/svg/icone-sucesso.svg) no-repeat center;
    }

    &.icon--alert {
      background: url(~@/assets/svg/Icon-Alert.svg) no-repeat center;
    }
  }
}

</style>
